export const GETTERS_LIST_PGP_CERTIFICATE = "GETTERS_LIST_PGP_CERTIFICATE";
export const GETTERS_PGPCERTIFICATE = "GETTERS_PGPCERTIFICATE";

// action
export const ACTION_GET_PGP_CERTIFICATE_LIST =
  "ACTION_GET_PGP_CERTIFICATE_LIST";
export const ACTION_GET_PGP_CERTIFICATE_LIST_BY_EMPLOYER =
  "ACTION_GET_PGP_CERTIFICATE_LIST_BY_EMPLOYER";
export const ACTION_DELETE_PGP_CERTIFICATE = "ACTION_DELETE_PGP_CERTIFICATE";
export const ACTION_GET_PGPCERTIFICATE = "ACTION_GET_PGPCERTIFICATE";
export const ACTION_SET_PGPCERTIFICATE = "ACTION_SET_PGPCERTIFICATE";

// mutation
export const MUTATION_SET_PGP_CERTIFICATE_LIST =
  "MUTATION_SET_PGP_CERTIFICATE_LIST";
export const MUTATION_SET_PGPCERTIFICATE = "MUTATION_SET_PGPCERTIFICATE";



// WEBPACK FOOTER //
// ./src/store/modules/pgp_certificate/constants.js